import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IValidationPeriod } from "src/models/Offers/ValidationPeriod.models";

interface ValidationPeriodState {
  validationPeriods: IValidationPeriod[];
  validationPeriodToEdit: IValidationPeriod | null;
}

const initialState: ValidationPeriodState = {
  validationPeriods: [],
  validationPeriodToEdit: null,
};

const ValidationPeriodSlice = createSlice({
  name: "ValidationPeriod",
  initialState,
  reducers: {
    setValidationPeriodList: (
      state,
      action: PayloadAction<IValidationPeriod[]>
    ) => {
      state.validationPeriods = action.payload;
    },
    concatListValidationPeriod: (
      state: ValidationPeriodState,
      action: PayloadAction<IValidationPeriod[]>
    ) => {
      state.validationPeriods = [
        ...state.validationPeriods.concat(action.payload),
      ];
    },
    setValidationPeriodToEdit: (
      state,
      action: PayloadAction<IValidationPeriod | null>
    ) => {
      state.validationPeriodToEdit = action.payload;
    },
    addValidationPeriod: (state, action: PayloadAction<IValidationPeriod>) => {
      state.validationPeriods.push(action.payload);
    },
    updateValidationPeriod: (
      state,
      action: PayloadAction<IValidationPeriod>
    ) => {
      let itemIndex = state.validationPeriods.findIndex(
        item => item.validationPeriodId === action.payload.validationPeriodId
      );
      if (itemIndex !== -1) state.validationPeriods[itemIndex] = action.payload;
    },
    deleteValidationPeriod: (state, action: PayloadAction<number>) => {
      const newArray = state.validationPeriods.filter(
        item => item.validationPeriodId !== action.payload
      );
      state.validationPeriods = newArray;
    },
  },
});

export const {
  setValidationPeriodList,
  concatListValidationPeriod,
  setValidationPeriodToEdit,
  addValidationPeriod,
  updateValidationPeriod,
  deleteValidationPeriod,
} = ValidationPeriodSlice.actions;

export default ValidationPeriodSlice.reducer;
